import api from './request.js';
import axios from "axios";
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
    config => {
        config.withCredentials = true;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

const updata = axios.create({
    baseURL:'/towerTreatment',
})

const request = axios.create({
    baseURL: '/',
})
const hyrequest = axios.create({
    baseURL: '/hyrequest',
    timeout: 3000
})
const asiaInfoApi = axios.create({
    baseURL: '/aMap',
})

const xydapi = axios.create({
    baseURL: '/xydapi',
})


const getLoadApi = axios.create({
    baseURL: '/aMap/',
    timeout: 300000
})


const geAsiaCurveDataApi = axios.create({
    baseURL: '/getAsiaCurveData/',
    timeout: 300000
})
const weatherApi = axios.create({
    baseURL: '/aMap',
})
const getYgyaApi = axios.create({
    baseURL: '/aMap',
})

const getsztMeasureApi = axios.create({
    baseURL: '/getTimeMeasure',
})



export const updataTemporaryData = (params) => updata({
    url: "/updateData",
    method: 'post',
    data: params,
})
export const postXydRequest = (url,params) => xydapi({
    url: url,
    method: 'post',
    data: params,
})



export const getTimeMeasure = (params) => getsztMeasureApi({
    url: "/getTimeMeasure",
    method: 'post',
    data: params,
})

export const getGzjb = (params) => hyrequest({
    url: '/operationalEvent/getGzjb',
    method: 'get',
    params: params,
})

// 模糊查询
export function postMyCenterLocation(params, _this) {
    return api({
        url: '/gis/public/api/fuzzyQueryMain', // 请求地址
        method: 'post', // 请求方式
        data: params, // (一般post请求，我们习惯使用 data属性来传参)
        cancelToken: new axios.CancelToken((c) => {
            _this.cancelFun = c
        }),
    })
}

//查询供电所河运维单位

export const getVenueList = (url) => request({
    url: "./data/venue.json",
    method: 'get', // 请求方式
})

export const getYCVenueList = (url) => request({
    url: "./data/yc_venue.json",
    method: 'get', // 请求方式
})



export const postTideWay = (params) => api({
    url: '/gis/public/api/lineTide',
    method: 'post',
    data: params,
})
export const getDirectLoad = (params) => api({
    url: '/gis/public/api/directLoad',
    method: 'get',
    data: params,
})

export const getYgyaMsgData = (url) => getYgyaApi({
    url: url,
    method: 'get',
})

export const getAsiaLinePower = (params) => api({
    url: "gis/public/api/getLinePower",
    method: 'post'
})

// 潮流
export const postOrienTation = (params) => api({
    url: '/gis/public/api/orienTation',
    method: 'post',
    data: params,
})

export const getLocalJson = (url) => request({
    url: url,
    method: 'get', // 
})


export const syncGetLocalJson = (url) => request({
    url: url,
    method: 'get', // 
    async:false
})

export const getDemoGzlb = (params) => request({
    url: './data/gzlb.json',
    method: 'get',
    params: params,
    async:false
})
export const getEverydayNews = (params) => asiaInfoApi({
    url: '/',
    method: 'get',
    params: params, 
    async:false
})




export const getAsiaCurveData = (url,params) => geAsiaCurveDataApi({
    url:url,
    method: 'post',
    data: params,
})

export const getLoad = (params) => getLoadApi({
    url: '',
    method: 'get',
    params: params,
})
// 故障定位
export const getMalfunctionLine = (params) => api({
    url: '/gis/public/api/getMalfunctionLine',
    method: 'get',
    params: params
})


export const getWeatherData = (params) => weatherApi({
    url: '',
    method: 'get',
    params: params,
})
export const getSingleWeather = (params) => weatherApi({
    url: '',
    method: 'get',
    params: params,
})
export const getSuperiorSubordinate = (params) => api({
    url: '/gis/public/api/getSuperiorSubordinate',
    method: 'get',
    params: params,
})





